/*
 * Application Insights JavaScript SDK - Common, 2.7.1
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */

/**
 * Type of storage to differentiate between local storage and session storage
 */
export var StorageType;
(function (StorageType) {
  StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
  StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
})(StorageType || (StorageType = {}));
export var DistributedTracingModes;
(function (DistributedTracingModes) {
  /**
   * (Default) Send Application Insights correlation headers
   */
  DistributedTracingModes[DistributedTracingModes["AI"] = 0] = "AI";
  /**
   * Send both W3C Trace Context headers and back-compatibility Application Insights headers
   */
  DistributedTracingModes[DistributedTracingModes["AI_AND_W3C"] = 1] = "AI_AND_W3C";
  /**
   * Send W3C Trace Context headers
   */
  DistributedTracingModes[DistributedTracingModes["W3C"] = 2] = "W3C";
})(DistributedTracingModes || (DistributedTracingModes = {}));